export default __webpack_public_path__ + "static/media/jo.5e426c88.svg";